/*
 * Vídeos con sonido (hero de la landing editorial de Broome): suenan solos, pero solo
 * mientras se ven.
 *
 * Los navegadores no dejan arrancar un vídeo con sonido si el usuario aún no ha tocado la
 * página: `play()` sin `muted` se rechaza y el vídeo se queda parado. Aquí:
 *  - se intenta con sonido; si se rechaza, arranca mudo y el sonido se activa en el primer
 *    gesto del usuario (toque, clic, tecla; el scroll no cuenta como permiso);
 *  - con menos de la mitad del vídeo en pantalla se pausa, y al volver sigue donde iba;
 *  - al cambiar de pestaña se pausa;
 *  - el botón de altavoz silencia o activa el sonido, y esa elección manda sobre lo demás.
 * Marca el vídeo con `data-lej-playing` en cuanto avanza, para retirar el póster (snippet
 * `lej-video-poster`), igual que `lej-video-autoplay.js`.
 * Afecta solo a los `<video data-lej-sound>`. Su botón es `[data-lej-sound-toggle]` dentro
 * del mismo `[data-lej-sound-box]`.
 */
(function () {
  if (window.lejVideoSound) return;
  window.lejVideoSound = true;

  var GESTURES = ['pointerup', 'touchend', 'click', 'keydown'];
  var VISIBLE = 0.5;

  function boxOf(v) {
    return v.closest('[data-lej-sound-box]');
  }

  function syncButton(v) {
    var box = boxOf(v);
    var btn = box && box.querySelector('[data-lej-sound-toggle]');
    if (btn) btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
  }

  // Sonido salvo que el usuario lo haya quitado con el botón o que el navegador aún no lo
  // permita (sin gesto previo).
  function play(v) {
    if (document.hidden || !v._lejVisible) return;
    v.muted = v._lejUserMuted || !v._lejAllowed;
    syncButton(v);
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        if (v.muted) return;
        v._lejAllowed = false;
        v.muted = true;
        syncButton(v);
        armGestures(v);
        v.play().catch(function () {});
      });
    }
  }

  function armGestures(v) {
    if (v._lejArmed) return;
    v._lejArmed = true;
    function onGesture(e) {
      // El clic en el propio botón ya decide el sonido: no se adelanta aquí.
      if (e.target.closest && e.target.closest('[data-lej-sound-toggle]')) return;
      v._lejAllowed = true;
      v._lejArmed = false;
      for (var i = 0; i < GESTURES.length; i++) {
        document.removeEventListener(GESTURES[i], onGesture, { capture: true });
      }
      if (v._lejVisible && !v._lejUserMuted) {
        v.muted = false;
        syncButton(v);
        if (v.paused) play(v);
      }
    }
    for (var i = 0; i < GESTURES.length; i++) {
      document.addEventListener(GESTURES[i], onGesture, { passive: true, capture: true });
    }
  }

  function markPlaying(v) {
    function onTime() {
      if (v.currentTime > 0) {
        v.setAttribute('data-lej-playing', '');
        v.removeEventListener('timeupdate', onTime);
      }
    }
    v.addEventListener('timeupdate', onTime);
    onTime();
  }

  // `<source media>` solo se evalúa al cargar: si la ventana cruza el breakpoint (tablet que
  // gira, ventana que cambia de tamaño, DevTools), el vídeo se queda con la fuente del otro
  // tamaño. Al cruzarlo, se vuelve a cargar para que elija la suya.
  function followMedia(v, after) {
    if (!window.matchMedia) return;
    var sources = v.querySelectorAll('source[media]');
    function wanted() {
      var all = v.querySelectorAll('source');
      for (var i = 0; i < all.length; i++) {
        var m = all[i].getAttribute('media');
        if (!m || window.matchMedia(m).matches) return all[i].src;
      }
      return '';
    }
    function onChange() {
      var src = wanted();
      if (!src || src === v.currentSrc) return;
      v.removeAttribute('data-lej-playing');
      v.load();
      markPlaying(v);
      after(v);
    }
    for (var i = 0; i < sources.length; i++) {
      var mq = window.matchMedia(sources[i].getAttribute('media'));
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  function watch(v) {
    if (v.dataset.lejSoundBound) return;
    v.dataset.lejSoundBound = '1';
    v._lejAllowed = true;
    v._lejUserMuted = false;
    v._lejVisible = false;
    v.setAttribute('playsinline', '');
    markPlaying(v);
    followMedia(v, play);

    var box = boxOf(v);
    var btn = box && box.querySelector('[data-lej-sound-toggle]');
    if (btn) {
      btn.addEventListener('click', function () {
        // Pulsar el botón es un gesto: a partir de aquí el navegador ya deja sonar.
        v._lejAllowed = true;
        v._lejUserMuted = !v.muted;
        v.muted = v._lejUserMuted;
        syncButton(v);
        if (v.paused && v._lejVisible) play(v);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            v._lejVisible = entries[i].intersectionRatio >= VISIBLE;
            if (v._lejVisible) play(v);
            else v.pause();
          }
        },
        { threshold: [0, VISIBLE] }
      ).observe(v);
    } else {
      v._lejVisible = true;
      play(v);
    }
  }

  function init() {
    var list = document.querySelectorAll('video[data-lej-sound]');
    for (var i = 0; i < list.length; i++) watch(list[i]);
  }

  document.addEventListener('visibilitychange', function () {
    var list = document.querySelectorAll('video[data-lej-sound]');
    for (var i = 0; i < list.length; i++) {
      if (document.hidden) list[i].pause();
      else play(list[i]);
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
